import React from 'react';
//style
import useStyles from './OrderDetailWhim.styles';
// Utils
import { formatCurrency } from '../../utils/CurrencyUtils';
// Components
import CustomButton from './../common/buttons/custom-button/CustomButton';

const OrderDetailWhim = ({
  deleteComment,
  openDeleteDialogOrderWhim,
  orderId,
  showDeleteWhim,
  title,
  whimId,
  whimName,
  whimPrice,
}) => {
  const componentClasses = useStyles();
  return (
    <div className={componentClasses.content}>
      <div className={componentClasses.title}>{title}</div>
      <div className={componentClasses.whimContent}>
        <div>{whimName}</div>
        <div>{formatCurrency(whimPrice)}</div>
      </div>
      {showDeleteWhim && (
        <CustomButton
          classes={{ root: componentClasses.deleteWhim }}
          color='secondary'
          text={deleteComment}
          type='submit'
          onClick={() => {
            openDeleteDialogOrderWhim(whimId);
          }}
        />
      )}
    </div>
  );
};
OrderDetailWhim.defaultProps = {
  classes: {},
};
export default OrderDetailWhim;
